module.exports = "td{\r\n    border: 1px solid #ddd;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/planning/revised-drawing/revised-drawing-grid/revised-drawing-grid.component.css
// module id = ./src/app/planning/revised-drawing/revised-drawing-grid/revised-drawing-grid.component.css
// module chunks = main